export default "__VITE_ASSET__BlMuS9Hw__"